import { render, staticRenderFns } from "./CreateCompanyDialog.vue?vue&type=template&id=24f4ac5e&"
import script from "./CreateCompanyDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateCompanyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCompanyDialog.vue?vue&type=style&index=0&id=24f4ac5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports